import { Component, OnInit } from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormFixeddesignPreviewComponent } from "../form-fixeddesign-preview/form-fixeddesign-preview.component";

@Component({
  selector: "formdocs-fixeddesign-forms",
  templateUrl: "./fixeddesign-forms.component.html",
  styleUrls: ["./fixeddesign-forms.component.scss"],
})
export class FixeddesignFormsComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  openDialog(formType: string): void {
    const dialogRef = this.dialog.open(FormFixeddesignPreviewComponent, {
      data: formType,
      autoFocus: false,
      maxHeight: "90vh",
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  ngOnInit() {}
}
